<template>
    <div class="wrap-add-deposit">
        <div class="wrap-content">
            <div class="title-page">Add Deposit</div>
            <div class="content">
                <div v-if="metal_info">
                    <div class="content-depositor">
                        <div>
                            <span>Owner</span>
                            <span>{{ owner }}</span>
                        </div>
                        <div>
                            <span>Deposit Date</span>
                            <span>{{ deposit_date }}</span>
                        </div>
                        <div>
                            <span>Permission IBOSS</span>
                            <span>{{ id_ijin }}</span>
                        </div>
                        <div>
                            <span>Permission Seri</span>
                            <span>{{ no_seri.value }}</span>
                        </div>
                        <div>
                            <span>Remaining Volume</span>
                            <span>{{ no_seri.remaining_volume.toFixed(5) + " kg" }}</span>
                        </div>
                    </div>
                    <div class="text-right">
                        <button type="button" class="btn btn-primer mb-3" @click="showModal">Add More Deposit</button>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Metal Form</th>
                                <th>Contract Id</th>
                                <th>Allocated</th>
                                <th>Dimension (mm<sup>3</sup>)</th>
                                <th>Fineness</th>
                                <th>Hallmark</th>
                                <th>Weight (gr)</th>
                                <th>Serial Number</th>
                                <th>Hub</th>
                                <th>Year</th>
                                <th>Description</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(metal, i) in metal_info" :key="i">
                                <td>{{ metal.metal_form }}</td>
                                <td>{{ metal.contract_id }}</td>
                                <td>{{ metal.allocated }}</td>
                                <td>{{ metal.dimension }}</td>
                                <td>{{ metal.fineness }}</td>
                                <td>{{ metal.hallmark }}</td>
                                <td>{{ metal.weight }}</td>
                                <td>{{ metal.serial_number }}</td>
                                <td>{{ metal.hub }}</td>
                                <td>{{ metal.year }}</td>
                                <td>{{ metal.item_description }}</td>
                                <td>
                                    <b-button variant="info" size="sm" @click="openModal(metal, i)">Edit</b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="mt-3 text-right">
                        <b-button variant="success" @click="submitMetal">
                            <b-spinner v-if="isLoading" small></b-spinner>
                            <span v-else>Submit</span>
                        </b-button>
                    </div>
                </div>
                <div class="text-center" v-else>
                    <h4>No data Available</h4>
                    <button type="button" class="btn btn-primer" @click="showModal">Add Deposit</button>
                </div>
                <b-modal ref="add-deposit" hide-footer title="Add Deposit">
                    <div class="d-block">
                        <form action="">
                            <h5>Depositor</h5>
                            <div class="form-group">
                                <label>Permission IBOSS</label>
                                <select class="form-input" v-model="id_ijin">
                                    <option value="" selected disabled>Choose Permission IBOSS</option>
                                    <option v-for="(permission, i) in dataPermission" :key="i" :value="permission.id_ijin" v-show="permission.idlayan == '009003'">
                                        ( {{ permission.no_pendaftaran }} ) {{ permission.urailayan }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Permission Series</label>
                                <select class="form-input" v-model="no_seri">
                                    <option value="" selected disabled>Choose Seri</option>
                                    <option
                                        v-for="(commodity, i) in commodityData"
                                        :key="i"
                                        :value="{ value: commodity.seri, remaining_volume: commodity.sisa_kuota }"
                                    >
                                        {{ commodity.seri }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Depositor</label>
                                <select class="form-input" v-model="owner">
                                    <option value="" selected disabled>Select depositor</option>
                                    <option v-for="(owner, i) in getDataClient" :key="i" :value="owner" v-show="owner != ''">{{ owner }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Deposit Date</label>
                                <input type="date" v-model="deposit_date" placeholder="deposite date" :max="today" class="form-input" />
                            </div>

                            <h5>Metal Info</h5>
                            <div class="form-group">
                                <label>Trading Contract</label>
                                <select class="form-input" v-model="form.contract_id">
                                    <option v-for="(contract, i) in dataContract" :key="i" :value="contract.contract_id">{{ contract.contract_name }}</option>
                                </select>
                            </div>
                            <div>
                                <label class="form-label">Metal Type</label>
                                <select class="form-input" v-model="form.metal_form">
                                    <option value="cast">Cast</option>
                                    <option value="mint">Mint</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Allocated</label>
                                <select class="form-input" v-model="form.allocated">
                                    <option value="ALL">ALL</option>
                                    <option value="pool">Pool</option>
                                    <option value="non pool">Non Pool</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Dimension (mm<sup>3</sup>) </label>
                                <input type="text" v-model="lenghtDim" placeholder="length" class="form-input dimension" />
                                <input type="text" v-model="widthDim" placeholder="width" class="form-input dimension" />
                                <input type="text" v-model="hightDim" placeholder="height" class="form-input dimension" />
                            </div>
                            <div class="form-group">
                                <label>Fineness</label>
                                <input type="text" v-model="form.fineness" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Hallmark</label>
                                <input type="text" v-model="form.hallmark" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Weight (gr)</label>
                                <input type="text" v-model="form.weight" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Serial Number</label>
                                <input type="text" v-model="form.serial_number" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Year</label>
                                <input type="text" v-model="form.year" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <input type="text" v-model="form.item_description" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Hub</label>
                                <input type="text" v-model="form.hub" readonly class="form-input" />
                            </div>
                        </form>
                    </div>
                    <div class="text-right">
                        <b-button class="mt-3" variant="primary" @click="addMetal"> Add Metal </b-button>
                    </div>
                </b-modal>
                <b-modal ref="edit-metal" hide-footer title="Edit Metal">
                    <div class="d-block">
                        <form action="">
                            <div class="form-group">
                                <label>Trading Contract</label>
                                <select class="form-input" v-model="form.contract_id">
                                    <option v-for="(contract, i) in dataContract" :key="i" :value="contract.contract_id">{{ contract.contract_name }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Metal Type</label>
                                <select class="form-input" v-model="form.metal_form">
                                    <option value="cast">Cast</option>
                                    <option value="mint">Mint</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Allocated</label>
                                <select class="form-input" v-model="form.allocated">
                                    <option value="ALL">ALL</option>
                                    <option value="pool">Pool</option>
                                    <option value="non pool">Non Pool</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Dimension (mm<sup>3</sup>) </label>
                                <input type="text" v-model="lenghtDim" placeholder="length" class="form-input dimension" />
                                <input type="text" v-model="widthDim" placeholder="width" class="form-input dimension" />
                                <input type="text" v-model="hightDim" placeholder="height" class="form-input dimension" />
                            </div>
                            <div class="form-group">
                                <label>Fineness</label>
                                <input type="text" v-model="form.fineness" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Hallmark</label>
                                <input type="text" v-model="form.hallmark" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Weight (gr)</label>
                                <input type="text" v-model="form.weight" class="form-input" />
                                <!-- <small v-if="no_seri.remaining_volume">
                                    <i>Remaining Volume : {{ (no_seri.remaining_volume * 1000).toFixed(2) + " gr" }}</i>
                                </small> -->
                            </div>
                            <div class="form-group">
                                <label>Serial Number</label>
                                <input type="text" v-model="form.serial_number" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Year</label>
                                <input type="text" v-model="form.year" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Description</label>
                                <input type="text" v-model="form.item_description" class="form-input" />
                            </div>
                            <div class="form-group">
                                <label>Hub</label>
                                <input type="text" v-model="form.hub" readonly class="form-input" />
                            </div>
                        </form>
                    </div>
                    <div class="text-right">
                        <b-button class="mt-3" variant="primary" @click="editMetal"> Edit Metal </b-button>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            dataPermission: [],
            commodityData: [],
            metal_info: [],
            dataContract: [],
            deposit_date: "",
            isLoading: false,
            isFormNull: false,
            lenghtDim: "",
            widthDim: "",
            hightDim: "",
            today: "",
            owner: "",
            id_ijin: "",
            no_seri: {
                remaining_volume: "",
                value: "",
            },
            detailVolum: "",
            idMetal: "",
            form: {
                contract_id: "",
                allocated: "",
                hub: "Jakarta",
                dimension: "",
                fineness: "",
                hallmark: "",
                weight: "",
                serial_number: "",
                year: "",
                item_description: "",
                metal_form: "",
            },
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        axios.get("/v2/attributes/contract").then((res) => {
            this.dataContract = res.data.data.body;
        });
        let dataOwner = JSON.parse(sessionStorage.getItem("owner"));
        this.metal_info = JSON.parse(sessionStorage.getItem("metal_info"));
        if (dataOwner) {
            this.id_ijin = dataOwner.id_ijin;
            this.no_seri.value = dataOwner.seri.value;
            this.no_seri.remaining_volume = dataOwner.seri.remaining_volume;
            this.deposit_date = dataOwner.deposite_date;
            this.owner = dataOwner.owner;
        }

        axios.get("/v2/clearing/admin/abx/get/list_ijin").then((res) => {
            this.dataPermission = res.data.data.body;
        });

        this.$store.dispatch("getDataClient", "onexchange");
    },
    watch: {
        id_ijin() {
            if (this.id_ijin != "") {
                this.ibossID(this.id_ijin);
            }
        },
    },
    computed: {
        getDataClient() {
            return this.$store.state.vaultModul.dataClient;
        },
        volume_gold() {
            let data = Math.round(this.no_seri.remaining_volume).toFixed(2);
            return data;
        },
    },
    beforeDestroy() {
        sessionStorage.removeItem("owner");
        sessionStorage.removeItem("metal_info");
    },
    methods: {
        openModal(metal, idMetal) {
            this.idMetal = idMetal;
            this.$refs["edit-metal"].show();
            this.form = {
                contract_id: metal.contract_id,
                allocated: metal.allocated,
                hub: "Jakarta",
                dimension: metal.dimension,
                fineness: metal.fineness,
                hallmark: metal.hallmark,
                weight: metal.weight,
                serial_number: metal.serial_number,
                year: metal.year,
                item_description: metal.item_description,
                metal_form: metal.metal_form,
            };
            let dimension = metal.dimension.split("x");
            this.lenghtDim = dimension[0];
            this.widthDim = dimension[1];
            this.hightDim = dimension[2];
        },
        editMetal() {
            this.metal_info[this.idMetal] = this.form;
            sessionStorage.setItem("metal_info", JSON.stringify(this.metal_info));
            this.$refs["edit-metal"].hide();
            location.reload();
        },
        ibossID(event) {
            axios.get("/v2/clearing/admin/abx/get/detail_ijin/" + event).then((res) => {
                this.commodityData = res.data.data.komoditas;
            });
        },
        showModal() {
            this.$refs["add-deposit"].show();
            this.form = {
                contract_id: "",
                allocated: "",
                hub: "Jakarta",
                dimension: "",
                fineness: "",
                hallmark: "",
                weight: "",
                serial_number: "",
                year: "",
                item_description: "",
                metal_form: "",
            };
            this.lenghtDim = "";
            this.widthDim = "";
            this.hightDim = "";
        },
        addMetal() {
            this.form.dimension = this.lenghtDim + "x" + this.widthDim + "x" + this.hightDim;
            this.form.weight = Number(this.form.weight);
            if (this.metal_info) {
                this.metal_info.push(this.form);
            } else {
                let data = [];
                data.push(this.form);
                this.metal_info = data;
            }
            let dataOwner = {
                deposite_date: this.deposit_date,
                owner: this.owner,
                id_ijin: this.id_ijin,
                seri: this.no_seri,
            };
            sessionStorage.setItem("metal_info", JSON.stringify(this.metal_info));
            sessionStorage.setItem("owner", JSON.stringify(dataOwner));
            this.$refs["add-deposit"].hide();
            this.isFormNull = true;
        },
        submitMetal() {
            this.isLoading = true;
            this.$store.dispatch("getLocation").then((resGeo) => {
                let info;
                if (resGeo.cityData[0]) {
                    info = JSON.stringify(resGeo);
                } else {
                    let data = resGeo;
                    data.newLatLong = resGeo.cityLatLong.split(",");
                    info = JSON.stringify(data);
                }
                let dataSubmit = {
                    info: info,
                    deposite_date: this.deposit_date,
                    owner: this.owner,
                    id_ijin: this.id_ijin,
                    seri: this.no_seri.value,
                    metal_info: this.metal_info,
                };
                axios
                    .post("v2/clearing/admin/abx/deposit", dataSubmit)
                    .then((res) => {
                        if (res.data.data.status_code == "00") {
                            this.$toast.success(res.data.message);
                            sessionStorage.removeItem("metal_info");
                            sessionStorage.removeItem("owner");
                            setTimeout(function () {
                                location.reload();
                            }, 2000);
                            this.isLoading = false;
                        }
                    })
                    .catch((error) => {
                        let errMsg;
                        if (error.response.data.data.err_message) {
                            errMsg = error.response.data.data.err_message;
                        } else {
                            errMsg = error.response.data.message;
                        }
                        this.isLoading = false;
                        this.$toast.error(errMsg);
                    });
            });
        },
    },
};
</script>

<style scoped>
.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

.form-group {
    font-size: 15px;
}

.form-group label {
    width: 30%;
}

.form-input {
    width: 70%;
    padding: 0.16rem 0.5rem;
    border-radius: 5px;
    border: 0.5px solid;
    font-size: 14px;
}

.dimension {
    width: 21%;
    margin-right: 1rem;
}

.dimension:last-child {
    margin: unset;
}

.content-depositor div {
    display: flex;
    gap: 1rem;
}

.content-depositor div span:first-child {
    width: 8rem;
}
.content-depositor div span:last-child {
    font-weight: bold;
}

.form-group small {
    margin-left: 30%;
}
</style>
